import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appMarginLeft]',
    standalone: false
})
export class MarginLeftDirective {
  constructor(element: ElementRef) {
    element.nativeElement.style.marginLeft = '16px';
  }
}
